<template>
  <div>
    <ConfigBox
      v-if="isKyc"
      :formIsInvalid="$v.recipient.$invalid"
      :callback="save"
      :title="$t('recipients.details.box.recipient_identification')"
      :hideEditButton="true"
    >
      <template #content>
        <RecipientBasicData
          :recipient="recipient"
          :canEdit="false"
        />
      </template>
    </ConfigBox>
    <ConfigBox
      :formIsInvalid="$v.recipient.$invalid"
      :callback="save"
      :title="$t('recipients.details.box.recipient_identification')"
      :hideEditButton="true"
      v-else
    >
      <template #content>
        <Identification
          :recipient="recipient"
          :default_bank_account="default_bank_account"
          :vuelidate="$v"
          :canEdit="false"
        />
      </template>
    </ConfigBox>

    <ConfigBox
      :hideEditButton="hideInfoEditButton"
      :callback="save"
      :title="$t('recipients.details.box.info')"
      :hasPassword="true"
      :mfaNeeded="!hasUserTwoFactorAuthentication"
    >
      <template #content>
        <Recipient
          :kyc="isKyc"
          :canSearchZipCode="canSearchZipCode"
          :recipient="recipient"
          :vuelidate="$v"
          :isCpf="isCpf"
          :locks="locks"
        />
      </template>
    </ConfigBox>
  </div>
</template>

<script>
import RecipientBasicData from '../../Form/RecipientBasicData.vue'
import ConfigBox from '@/components/project/molecules/ConfigBox.vue'
import Identification from '../../Form/Identification.vue'
import Recipient from '../../Form/Recipient.vue'
import { mapGetters } from 'vuex'

import { personalUser, corporationUser } from '../../Form/validations'
import { buildRegisterInformationBody } from '@/utils/recipient-register-information.utils'

export default {
  name: 'RecipientData',
  components: {
    ConfigBox,
    RecipientBasicData,
    Identification,
    Recipient
  },
  props: {
    recipient: {
      type: Object,
      required: true
    },
    default_bank_account: {
      type: Object,
      required: true
    },
    canSearchZipCode: {
      type: Boolean,
      default: true
    },
    isCpf: Boolean,
    locks: {
      type: Object,
      default: () => ({})
    },
    recipientDetail: {
      type: Object,
      default: () => ({})
    },
    canEditRegisterInformation: Boolean,
    isKyc: Boolean
  },
  computed: {
    ...mapGetters(['hasUserTwoFactorAuthentication']),
    hideInfoEditButton () {
      if (!this.isKyc) return false
      return !this.canEditRegisterInformation
    }
  },
  validations () {
    return {
      recipient: !this.isKyc || this.isCpf ? personalUser : corporationUser
    }
  },
  methods: {
    save (password) {
      const ids = {
        merchantId: this.$route.params.merchant_id,
        accountId: this.$route.params.account_id,
        recipientId: this.$route.params.id
      }

      if (!this.isKyc) {
        return this.$store.dispatch('UPDATE_RECIPIENT_GENERAL_SETTINGS', {
          ...ids,
          body: {
            ...this.recipient,
            password
          }
        })
      }

      return this.saveRegisterInformation(ids, password)
    },
    saveRegisterInformation (ids, password) {
      const body = {
        ...buildRegisterInformationBody(this.recipient, this.recipientDetail),
        password
      }

      return this.$store
        .dispatch('UPDATE_RECIPIENT_REGISTER_INFORMATION', { ...ids, body })
        .then(res => {
          this.$emit('updated')
          return res
        })
    }
  }
}
</script>
